export default "__VITE_ASSET__0d766ddb__"